import React, { useMemo } from 'react';
import OptionCard from '../option-card/option-card';
import type { NodeType } from '../option-card/option-card.types';
import type { OptionCardGroup as Props } from './option-card-group.types';

/** https://www.figma.com/design/CemEcLe6DpoD5ELrFqlwZ7/shared-web-components?node-id=13654-17548 */
const OptionCardGroup = <T extends NodeType>({
  entries,
  onInteraction: handleInteraction,
}: Props<T>) => {
  // NOTE: Calculated here because it should not be possible to
  // use a grid with an odd number of entries.
  const mode = useMemo<'grid' | 'list'>(
    () => (entries.length % 2 ? 'list' : 'grid'),
    [entries.length]
  );

  return (
    <div className="option-card-group">
      <div
        className={`option-card-group__entries option-card-group__entries--${mode} option-card-group__entries--${entries.length}`}
      >
        {entries.map(entry => (
          <div className="option-card-group__entry" key={entry.key}>
            <OptionCard {...entry.props} onInteraction={handleInteraction} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OptionCardGroup;
